export const formatChatRequest = (
  chatID: string,
  message: string,
  webSearchEnabled: boolean,
  reasoningEnabled: boolean,
  uploadFile?: File,
) => {
  const formData = new FormData();
  if (uploadFile) {
    formData.append("upload_file", uploadFile);
  }

  formData.append(
    "data",
    JSON.stringify({
      chat_id: chatID,
      question: message,
      web_search_enabled: webSearchEnabled,
      reasoning_enabled: reasoningEnabled,
    }),
  );

  return formData;
};
